// Frontend Configuration
// Switch between test and live mode here

const MODE = process.env.NODE_ENV === 'production' ? 'live' : 'test';

const config = {
  test: {
    stripePublishableKey: 'pk_test_51SGuM9AnNsTqUicQoLDvGovuAEKKUayQf5rWa4mH5sHkqGachXhVGzfcPmSCYHcXFlgzX8wr3la1tcB8ZLnD719K00bK3k5YT2',
    apiUrl: 'http://localhost:4242',
    googleDriveFolderId: '1yxSeW_qlPFQeRCcNIvuHkd3of1t9r-89' // All Things OVR Drive folder for gallery
  },
  live: {
    stripePublishableKey: 'pk_live_51SGuLyAS4HQkgmFGZozEogoaXq4nuOThVXDoHnfgMVdeS7pAGPm3r1d9yKpRgWl8jzeSSq48JjFv68kYP9FVFcu200vlOCTbko',
    apiUrl: '/api', // Use relative path for Vercel serverless functions
    googleDriveFolderId: '1yxSeW_qlPFQeRCcNIvuHkd3of1t9r-89' // All Things OVR Drive folder for gallery
  }
};

export default config[MODE];

